<template>
	<div class="ik-row">
		<div class="ik-tile ik-tile--main">
			<div class="ik-label">Opportunità aperte</div>
			<div class="ik-value">{{ euro(summary ? summary.impact : 0) }}</div>
			<div class="ik-muted">{{ summary ? summary.count : 0 }} consigli da fare</div>
		</div>
		<div
			v-for="a in aree"
			:key="a.area"
			class="ik-tile ik-tile--click"
			:class="{ 'ik-tile--active': selected === a.area }"
			role="button"
			tabindex="0"
			@click="$emit('select', selected === a.area ? '' : a.area)"
			@keyup.enter="$emit('select', selected === a.area ? '' : a.area)"
		>
			<div class="ik-label">
				<v-icon small :color="info(a.area).colore">{{ info(a.area).icona }}</v-icon> {{ info(a.area).label }}
			</div>
			<div class="ik-value ik-value--small">{{ euro(a.impact) }}</div>
			<div class="ik-muted">{{ a.count === 1 ? '1 consiglio' : a.count + ' consigli' }}</div>
		</div>
	</div>
</template>

<script>
import { area, euro } from './formato';

// testata della sezione: valore stimato delle opportunita' aperte, in totale e per area (clic = filtro area)
export default {
	name: 'InsightsKpi',
	props: {
		summary: { type: Object, default: null },
		selected: { type: String, default: '' },
	},
	computed: {
		aree() {
			return ((this.summary && this.summary.areas) || []).filter(a => a.count > 0 || a.area === this.selected);
		},
	},
	methods: {
		euro,
		info: area,
	},
};
</script>

<style scoped>
.ik-row {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
	gap: 12px;
}
.ik-tile {
	background: #fff;
	border: 1px solid #e3e8ef;
	border-radius: 8px;
	padding: 12px 14px;
	text-align: left;
}
.ik-tile--main {
	border-color: #1976d2;
	background: #f4f8fe;
}
.ik-tile--click {
	cursor: pointer;
}
.ik-tile--click:hover,
.ik-tile--active {
	border-color: #1976d2;
}
.ik-label {
	font-size: 12px;
	color: #5f6b7a;
}
.ik-value {
	font-size: 22px;
	font-weight: 600;
	color: #1f2d3d;
}
.ik-value--small {
	font-size: 18px;
}
.ik-muted {
	font-size: 12px;
	color: #5f6b7a;
}
</style>
